
                  import { Viewer } from "@photo-sphere-viewer/core";

                  const lobbyViewer = new Viewer({
                    container: document.querySelector("#lobby"),
                    panorama: '/images/VT/Lobby 2.jpg',
                    caption:'Main Lobby',
                    navbar:['zoom', 'move', 'caption'], 
                  });
                